import React from 'react';
import { Pagination, Form } from 'react-bootstrap';

const PaginationControls = ({
  pagination = {},
  meta = {},
  hasNextPage = false,
  hasPreviousPage = false,
  onPageChange = () => {},
  onLimitChange = () => {},
  onFirstPage = () => {},
  onLastPage = () => {},
  onNextPage = () => {},
  onPreviousPage = () => {},
}) => {
  
  // Generate page numbers
  const generatePageNumbers = () => {
    const currentPage = pagination.page || 1;
    const totalPages = meta.totalPages || 1;
    const pages = [];
    
    if (totalPages <= 7) {
      // Show all pages if total pages <= 7
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Show first, last, and pages around current
      if (currentPage <= 4) {
        // Near the beginning
        for (let i = 1; i <= 5; i++) pages.push(i);
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 3) {
        // Near the end
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 4; i <= totalPages; i++) pages.push(i);
      } else {
        // In the middle
        pages.push(1);
        pages.push('...');
        for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(i);
        pages.push('...');
        pages.push(totalPages);
      }
    }
    
    return pages;
  };

  const pageNumbers = generatePageNumbers();
  const startItem = ((pagination.page - 1) * pagination.limit) + 1;
  const endItem = Math.min(pagination.page * pagination.limit, meta.totalItems || 0);
  const totalItems = meta.totalItems || 0;

  return (
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 gap-3">
      {/* Items per page selector */}
      <div className="d-flex align-items-center gap-2">
        <span className="text-muted small">Show</span>
        <Form.Select 
          size="sm" 
          style={{ width: 'auto' }}
          value={pagination.limit}
          onChange={(e) => onLimitChange(parseInt(e.target.value))}
        >
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
        </Form.Select>
        <span className="text-muted small">per page</span>
      </div>

      {/* Pagination controls */}
      <Pagination className="mb-0">
        <Pagination.First 
          onClick={onFirstPage} 
          disabled={!hasPreviousPage}
        />
        <Pagination.Prev 
          onClick={onPreviousPage} 
          disabled={!hasPreviousPage}
        />
        
        {pageNumbers.map((pageNum, index) => {
          if (pageNum === '...') {
            return <Pagination.Ellipsis key={`ellipsis-${index}`} disabled />;
          }
          
          return (
            <Pagination.Item
              key={pageNum}
              active={pagination.page === pageNum}
              onClick={() => onPageChange(pageNum)}
            >
              {pageNum}
            </Pagination.Item>
          );
        })}
        
        <Pagination.Next 
          onClick={onNextPage} 
          disabled={!hasNextPage}
        />
        <Pagination.Last 
          onClick={onLastPage} 
          disabled={!hasNextPage}
        />
      </Pagination>

      {/* Results info */}
      <div className="text-muted small text-center text-md-end">
        Showing {startItem} to {endItem} of {totalItems} items
      </div>
    </div>
  );
};

export default PaginationControls;